import { FC, useRef } from 'react';

export interface Product3DViewProps {
  productUuid: string;
  productName: string;
}

export const Product3DView: FC<Product3DViewProps> = ({ productUuid, productName }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const iframeSource = `https://embed.vntana.com?productUuid=${productUuid}&clientSlug=products&organizationSlug=jabra&fullScreen=0&mobileARView=0&qrCode=0&centerButton=0`;
  return (
    <iframe
      tabIndex={-1}
      className="h-full w-full"
      ref={iframeRef}
      loading="lazy"
      src={iframeSource}
      title={productName}
    ></iframe>
  );
};
